<div class="zigbee-edit-container">
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'zigbee.edit.title' | translate }}</h2>
  </div>

  <div *ngIf="device == null">{{ 'zigbee.edit.not_found' | translate }}</div>

  <div *ngIf="device != null" class="zigbee-edit-form">
    <div class="basic-settings">
      <div class="form-group">
        <label>IEEE {{ device.ieee }}</label>
      </div>
      <div class="form-group">
        <label for="zbName">{{ 'zigbee.edit.name' | translate }}</label>
        <input id="zbName" type="text" [(ngModel)]="device.name" (change)="saveName()"
               [placeholder]="'zigbee.edit.name_placeholder' | translate" />
      </div>
      <div class="sensor-meta">
        <span>{{ typeName | translate }}</span>
        <span *ngIf="device.battery">{{ 'zigbee.edit.battery' | translate: { percent: device.battery } }}</span>
        <span>{{ (device.active === false ? 'zigbee.edit.inactive' : 'zigbee.edit.active') | translate }}</span>
      </div>
    </div>

    <h3>{{ 'zigbee.edit.notifications' | translate }}</h3>
    <p class="hint">{{ 'zigbee.edit.notify_hint' | translate }}</p>
    <div class="notify-block">
      <label *ngIf="device.type === 1" class="notify-row">
        <input type="checkbox" [(ngModel)]="device.notify!.leak" (change)="saveDevice()" />
        {{ 'zigbee.edit.alert_leak' | translate }}
      </label>
      <div *ngIf="device.type === 2" class="notify-row">
        <label><input type="checkbox" [(ngModel)]="notifyTempOn" (change)="saveDevice()" /> {{ 'zigbee.edit.temp_above' | translate }}</label>
        <input type="number" [(ngModel)]="notifyTempValue" (change)="saveDevice()" [disabled]="!notifyTempOn" /> °C
      </div>
      <div *ngIf="device.type === 2" class="notify-row">
        <label><input type="checkbox" [(ngModel)]="notifyHumOn" (change)="saveDevice()" /> {{ 'zigbee.edit.hum_above' | translate }}</label>
        <input type="number" [(ngModel)]="notifyHumValue" (change)="saveDevice()" [disabled]="!notifyHumOn" /> %
      </div>
      <p class="hint" *ngIf="device.type !== 1 && device.type !== 2">
        {{ 'zigbee.edit.no_notifications' | translate }}
      </p>
    </div>

    <h3>{{ 'zigbee.edit.rules' | translate }}</h3>
    <p class="hint">
      {{ 'zigbee.edit.rules_hint' | translate }}
    </p>

    <div class="rules-container">
      <div *ngFor="let rule of rules; let i = index" class="rule-card">
        <div class="rule-header">
          <label class="enabled-toggle">
            <input type="checkbox" [(ngModel)]="rule.enabled" /> {{ 'common.enabled' | translate }}
          </label>
          <button class="remove-button" (click)="removeRule(i)" [title]="'zigbee.edit.remove_rule' | translate">
            <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
          </button>
        </div>

        <div class="rule-grid">
          <div class="form-group">
            <label>{{ 'zigbee.edit.when' | translate }}</label>
            <select [(ngModel)]="rule.event">
              <option *ngFor="let e of events" [ngValue]="e.code">{{ e.name | translate }}</option>
            </select>
          </div>

          <div class="form-group" *ngIf="needsThreshold(rule)">
            <label>{{ 'zigbee.edit.threshold' | translate: { unit: thresholdUnit(rule) } }}</label>
            <input type="number" step="any" [(ngModel)]="rule.threshold" />
          </div>

          <div class="form-group">
            <label>{{ 'common.action' | translate }}</label>
            <select [(ngModel)]="rule.actionType">
              <option value="on">{{ 'common.on' | translate }}</option>
              <option value="off">{{ 'common.off' | translate }}</option>
              <option value="toggle">{{ 'common.toggle' | translate }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ 'common.output' | translate }}</label>
            <select [(ngModel)]="rule.outputEid">
              <option *ngFor="let o of outputs" [ngValue]="o.eid">{{ o.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ 'zigbee.edit.auto_off' | translate }}</label>
            <input type="number" min="0" [(ngModel)]="rule.durationSec" />
          </div>
        </div>
      </div>
    </div>

    <button class="add-button" (click)="addRule()">+ {{ 'zigbee.edit.add_rule' | translate }}</button>

    <h3 *ngIf="device.type === 1 || device.type === 3">{{ 'zigbee.edit.history' | translate }}</h3>
    <table class="events-table" *ngIf="(device.type === 1 || device.type === 3) && events_log.length">
      <tr *ngFor="let e of events_log">
        <td class="event-time">{{ e.happenedAt | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
        <td class="event-name" [class.alarm]="isAlarm(e.event)">{{ eventName(e.event) | translate }}</td>
      </tr>
    </table>
    <p class="hint" *ngIf="(device.type === 1 || device.type === 3) && !events_log.length">
      {{ 'zigbee.edit.no_events' | translate }}
    </p>

    <div class="form-actions">
      <button class="delete-button" (click)="confirmDelete = true">{{ 'zigbee.edit.delete' | translate }}</button>
      <button class="save-button" (click)="save()">{{ 'common.save' | translate }}</button>
    </div>
  </div>

  <div class="popup-overlay" *ngIf="confirmDelete">
    <div class="modal-dialog">
      <div class="modal-title">{{ 'zigbee.edit.delete_confirm' | translate }}</div>
      <div class="modal-actions">
        <button class="delete-button" (click)="deleteDevice()">{{ 'common.delete' | translate }}</button>
        <button (click)="confirmDelete = false">{{ 'common.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>
